// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-tile {
  position: fixed;
  top: 0;
  right: 0;
  width: 350px;
  background-color: #f8f9fa;
  height: 100vh; /* Legyen a teljes ablakmagasság */
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Igazítás felülről */
  padding: 20px;
  padding-top: 65px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1), width 0.5s cubic-bezier(0.25, 0.1, 0.25, 1), margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  overflow-y: auto; /* Engedélyezzük a görgetést */
  z-index: 10;
}


.side-tile.open {
  transform: translateX(0%);
  margin-right: 0;
  overflow-y: auto; /* Görgetés hozzáadása a megnyitott állapothoz */
}

.side-tile.closed {
  transform: translateX(100%);
  margin-right: -250px;
  overflow-y: hidden; /* Rejtjük el a görgetést a zárt állapotban */
}

.side-tile.preview {
  position: relative;
  top: auto;
  right: auto;
  width: 100%;
  height: auto;
  padding: 0;
  margin: 0;
  box-shadow: none;
  overflow: visible;
  transition: none;
  z-index: auto;
}

.side-tile.preview .content {
  max-height: none;
  padding-bottom: 0;
  overflow: visible;
}

.side-tile.preview .item:last-child {
  margin-bottom: 0;
}



/* Tartalom görgethetősége a side-tile-on belül */
.side-tile .content {
  max-height: calc(100vh - 65px); /* A teljes ablakmagasság mínusz a felső margó */
  overflow-y: auto; /* Görgetés hozzáadása a tartalomhoz */
  padding-bottom: 60px; /* Adjunk hozzá némi helyet a rögzített gombok számára */
  position: relative; /* Szükséges a belső pozicionáláshoz */
}



.toggle-button {
  background: white;
  color: #242943;
  border: 2px solid #50ADC9;
  padding: 5px 10px;
  cursor: pointer;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  z-index: 11;
  border-radius: 5px;
  transition: right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1), background 0.5s ease, box-shadow 0.5s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  font-size: 14px;
  font-weight: bold;
}

.toggle-button.closed {
  right: 0;
}

.toggle-button.open {
  right: 350px;
}

.toggle-button:hover {
  background: #f0f0f0;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.item {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  position: relative;
}

.item.active {
  background-color: #d3d3d3;
  padding: 12px 1px;
  border: 0px solid #d3d3d3;
  border-radius: 8px;
}

.circle {
  width: 18px;  /* Növeljük a méretet, hogy jobban illeszkedjen */
  min-width: 18px; /* Biztosítsuk, hogy a kör ne legyen kisebb */
  height: 18px;
  border-radius: 50%;
  background-color: grey;
  margin-right: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle.red {
  background-color: red;
}

.circle.yellow {
  background-color: yellow;
}

.circle.green {
  background-color: green;
}

.circle.green::after {
  content: "✔";  /* Pipa karakter */
  color: white;
  font-size: 12px; /* Pipa mérete */
  font-weight: bold; /* Erősített megjelenés */
  position: absolute;
}

.connector {
  width: 2px;
  height: 48px;
  background-color: #c0c0c0;
  position: absolute;
  left: 7px;
  top: 18px;
  z-index: -1;
}

.item:last-child .connector {
  display: none;
}

.separator {
  width: 100%;
  height: 2px; /* Vastagabb vonal */
  background-color: #c0c0c0;
  margin: 20px 0; /* Egyenlő térköz a vonal fölött és alatt */
}

.text-link {
  color: #000;
  text-decoration: none;
}

.text-link:hover {
  text-decoration: underline;
}

.text {
  margin: 0;
  font-size: 16px;
  line-height: 1;
}



/* Navigációs gombok rögzítése a képernyő aljához */
.navigation-arrows {
  position: fixed;
  bottom: 10px; /* A képernyő aljától 10px-re lesznek */
  left: 0px; /* A side-tile szélességéhez igazítva */
  width: 100%; /* Szélesség beállítása a side-tile-hoz igazítva */
  display: flex;
  justify-content: space-between;
  padding: 5px 10px; /* Belső margó a gombokhoz */
  background-color: #f8f9fa; /* Azonos háttérszín, mint a side-tile */
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1); /* Enyhe árnyék a gombok fölé */
  z-index: 15; /* Előrébb hozás az oldalsó menü elemek fölé */
  border-radius: 5px; /* Gombok keretének lekerekítése */
}

.navigation-arrows {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  width: 100%; /* Beállítás a teljes SideTile szélességére */
  padding: 10px; /* Adhatsz hozzá némi padding-et is, hogy szellősebb legyen */
  box-sizing: border-box; /* Biztosítsd, hogy a padding ne növelje a szélességet */
}



.nav-arrow {
  background-color: #50ADC9;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.nav-arrow:hover {
  background-color: #3a94b1;
}

.nav-arrow:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/SideTile.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,aAAa,EAAE,kCAAkC;EACjD,aAAa;EACb,sBAAsB;EACtB,2BAA2B,EAAE,sBAAsB;EACnD,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,4JAA4J;EAC5J,gBAAgB,EAAE,8BAA8B;EAChD,WAAW;AACb;;;AAGA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB,EAAE,gDAAgD;AACpE;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA,iDAAiD;AACjD;EACE,8BAA8B,EAAE,gDAAgD;EAChF,gBAAgB,EAAE,sCAAsC;EACxD,oBAAoB,EAAE,wDAAwD;EAC9E,kBAAkB,EAAE,sCAAsC;AAC5D;;;;AAIA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mGAAmG;EACnG,wCAAwC;EACxC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW,GAAG,iDAAiD;EAC/D,eAAe,EAAE,6CAA6C;EAC9D,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY,GAAG,kBAAkB;EACjC,YAAY;EACZ,eAAe,EAAE,gBAAgB;EACjC,iBAAiB,EAAE,yBAAyB;EAC5C,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW,EAAE,oBAAoB;EACjC,yBAAyB;EACzB,cAAc,EAAE,2CAA2C;AAC7D;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;;;AAIA,mDAAmD;AACnD;EACE,eAAe;EACf,YAAY,EAAE,uCAAuC;EACrD,SAAS,EAAE,uCAAuC;EAClD,WAAW,EAAE,kDAAkD;EAC/D,aAAa;EACb,8BAA8B;EAC9B,iBAAiB,EAAE,4BAA4B;EAC/C,yBAAyB,EAAE,wCAAwC;EACnE,yCAAyC,EAAE,+BAA+B;EAC1E,WAAW,EAAE,8CAA8C;EAC3D,kBAAkB,EAAE,kCAAkC;AACxD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW,EAAE,6CAA6C;EAC1D,aAAa,EAAE,6DAA6D;EAC5E,sBAAsB,EAAE,wDAAwD;AAClF;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".side-tile {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 350px;\n  background-color: #f8f9fa;\n  height: 100vh; /* Legyen a teljes ablakmagasság */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start; /* Igazítás felülről */\n  padding: 20px;\n  padding-top: 65px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 0;\n  transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1), width 0.5s cubic-bezier(0.25, 0.1, 0.25, 1), margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);\n  overflow-y: auto; /* Engedélyezzük a görgetést */\n  z-index: 10;\n}\n\n\n.side-tile.open {\n  transform: translateX(0%);\n  margin-right: 0;\n  overflow-y: auto; /* Görgetés hozzáadása a megnyitott állapothoz */\n}\n\n.side-tile.closed {\n  transform: translateX(100%);\n  margin-right: -250px;\n  overflow-y: hidden; /* Rejtjük el a görgetést a zárt állapotban */\n}\n\n.side-tile.preview {\n  position: relative;\n  top: auto;\n  right: auto;\n  width: 100%;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  box-shadow: none;\n  overflow: visible;\n  transition: none;\n  z-index: auto;\n}\n\n.side-tile.preview .content {\n  max-height: none;\n  padding-bottom: 0;\n  overflow: visible;\n}\n\n.side-tile.preview .item:last-child {\n  margin-bottom: 0;\n}\n\n\n\n/* Tartalom görgethetősége a side-tile-on belül */\n.side-tile .content {\n  max-height: calc(100vh - 65px); /* A teljes ablakmagasság mínusz a felső margó */\n  overflow-y: auto; /* Görgetés hozzáadása a tartalomhoz */\n  padding-bottom: 60px; /* Adjunk hozzá némi helyet a rögzített gombok számára */\n  position: relative; /* Szükséges a belső pozicionáláshoz */\n}\n\n\n\n.toggle-button {\n  background: white;\n  color: #242943;\n  border: 2px solid #50ADC9;\n  padding: 5px 10px;\n  cursor: pointer;\n  position: fixed;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 0;\n  z-index: 11;\n  border-radius: 5px;\n  transition: right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1), background 0.5s ease, box-shadow 0.5s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.toggle-button.closed {\n  right: 0;\n}\n\n.toggle-button.open {\n  right: 350px;\n}\n\n.toggle-button:hover {\n  background: #f0f0f0;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.item.active {\n  background-color: #d3d3d3;\n  padding: 12px 1px;\n  border: 0px solid #d3d3d3;\n  border-radius: 8px;\n}\n\n.circle {\n  width: 18px;  /* Növeljük a méretet, hogy jobban illeszkedjen */\n  min-width: 18px; /* Biztosítsuk, hogy a kör ne legyen kisebb */\n  height: 18px;\n  border-radius: 50%;\n  background-color: grey;\n  margin-right: 10px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.circle.red {\n  background-color: red;\n}\n\n.circle.yellow {\n  background-color: yellow;\n}\n\n.circle.green {\n  background-color: green;\n}\n\n.circle.green::after {\n  content: \"✔\";  /* Pipa karakter */\n  color: white;\n  font-size: 12px; /* Pipa mérete */\n  font-weight: bold; /* Erősített megjelenés */\n  position: absolute;\n}\n\n.connector {\n  width: 2px;\n  height: 48px;\n  background-color: #c0c0c0;\n  position: absolute;\n  left: 7px;\n  top: 18px;\n  z-index: -1;\n}\n\n.item:last-child .connector {\n  display: none;\n}\n\n.separator {\n  width: 100%;\n  height: 2px; /* Vastagabb vonal */\n  background-color: #c0c0c0;\n  margin: 20px 0; /* Egyenlő térköz a vonal fölött és alatt */\n}\n\n.text-link {\n  color: #000;\n  text-decoration: none;\n}\n\n.text-link:hover {\n  text-decoration: underline;\n}\n\n.text {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1;\n}\n\n\n\n/* Navigációs gombok rögzítése a képernyő aljához */\n.navigation-arrows {\n  position: fixed;\n  bottom: 10px; /* A képernyő aljától 10px-re lesznek */\n  left: 0px; /* A side-tile szélességéhez igazítva */\n  width: 100%; /* Szélesség beállítása a side-tile-hoz igazítva */\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 10px; /* Belső margó a gombokhoz */\n  background-color: #f8f9fa; /* Azonos háttérszín, mint a side-tile */\n  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1); /* Enyhe árnyék a gombok fölé */\n  z-index: 15; /* Előrébb hozás az oldalsó menü elemek fölé */\n  border-radius: 5px; /* Gombok keretének lekerekítése */\n}\n\n.navigation-arrows {\n  display: flex;\n  justify-content: space-between;\n  margin-top: auto;\n  width: 100%; /* Beállítás a teljes SideTile szélességére */\n  padding: 10px; /* Adhatsz hozzá némi padding-et is, hogy szellősebb legyen */\n  box-sizing: border-box; /* Biztosítsd, hogy a padding ne növelje a szélességet */\n}\n\n\n\n.nav-arrow {\n  background-color: #50ADC9;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n\n.nav-arrow:hover {\n  background-color: #3a94b1;\n}\n\n.nav-arrow:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
